import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Button } from 'homecredit-ui';
import { func, objectOf, any } from 'prop-types';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';

import { clearAlert } from 'actions/alert';
import Modal from 'components/common/Modal';
import { ENABLE_POPUP } from 'constants/localStorage';
import { sendGAEvent } from 'utils/ga';
import ZaloSearchDeals from 'routes/preScore/home/SearchApp/ZaloSearchDeals';
import s from './style.css';
import popup from '../images/popup.png';
import popupWebp from '../images/popup.web';
import docs, { LIST_AMOUNT } from './constant';
import LoanItem from './LoanItem';
import bannerImg from '../images/song-vui-3x.png';
import loanAmountImg from '../images/loan-amount.png';

class StartLoanComponent extends React.Component {
  static propTypes = {
    goToNextStep: func,
    settings: objectOf(any),
    resetAlert: func,
  };

  static defaultProps = {
    goToNextStep: noop,
    resetAlert: noop,
    settings: {},
  };

  constructor(props) {
    super(props);

    // Get from local storage
    const enablePopup = localStorage.getItem(ENABLE_POPUP);
    const isOpenModal =
      props.settings.enablePopup &&
      (isEmpty(enablePopup) ||
        JSON.parse(enablePopup).expiresIn < new Date().getTime());

    this.state = {
      isDirty: false,
      isOpenModal,
      isAboutModal: false,
    };
    this.trackingBounceRate = this.trackingBounceRate.bind(this);
  }

  componentDidMount() {
    this.props.resetAlert();
    sendGAEvent('Visit_Page', 'Introduction_Page', 'ACL_0BOD_Introduction');
    window.addEventListener('beforeunload', this.trackingBounceRate);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.trackingBounceRate);
  }

  onOpenAbout = e => {
    e.preventDefault();

    sendGAEvent(
      'Tap_About_HCVN_Button',
      'About_HCVN_Button',
      'ACL_0BOD_Introduction',
    );

    this.setState(({ isOpenModal }) => ({
      isOpenModal: !isOpenModal,
      isAboutModal: true,
    }));
  };

  onCloseModal = () => {
    this.setState({ isOpenModal: false, isAboutModal: false });
    this.cachePopupFunction();
  };

  cachePopupFunction = () => {
    localStorage.setItem(
      ENABLE_POPUP,
      JSON.stringify({
        expiresIn: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).getTime(),
      }),
    );
  };

  trackingBounceRate() {
    !this.state.isDirty &&
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Start Loan Page',
        eventAction: 'Bounce_rate',
        eventLabel: 'Start Loan Page',
      });
  }

  handleClick = async () => {
    sendGAEvent(
      'Tap_Continue_Button',
      'Continue_Button',
      'ACL_0BOD_Introduction',
    );
    this.props.goToNextStep();
  };

  render() {
    const { isOpenModal, isAboutModal } = this.state;

    return (
      <div className={s.container}>
        <div className={s.wrapper}>
          <div className="container">
            <div className={s.logoWrapper}>
              <img
                src={bannerImg}
                className={s.logo}
                alt="Sống vui cùng HomeCredit"
              />
              <p className={s.title}>SỐ TIỀN SƠ DUYỆT LÊN ĐẾN</p>
              <img
                src={loanAmountImg}
                className={s.slogan}
                alt="Số tiền được vay lên đến 200triệu"
              />
            </div>
            <div className={s.content}>
              <p className={s.notice}>
                Bạn có thể tự kiểm tra
                <strong> Miễn Phí </strong>
                số tiền có thể vay mà không cần gặp nhân viên tư vấn.
              </p>
              <Button onClick={this.handleClick} className={s.btnStart}>
                Bắt đầu vay ngay
              </Button>
              <a className={s.aboutHome} onClick={this.onOpenAbout}>
                <span>Về công ty Home Credit Việt Nam</span>
              </a>

              <div className={s.highLight}>
                <span>Ưu điểm nổi bật</span>
                {docs.map(item => <LoanItem {...item} key={item.label} />)}
              </div>

              <p className={s.dealsTitle}>
                Kiểm tra miễn phí khả năng duyệt cho gói vay:
              </p>
              <div className={classNames(s.deals, 'col-12')}>
                <ZaloSearchDeals listAmount={LIST_AMOUNT} />
                <p className={s.dealsnotice}>
                  *Kết quả này chỉ mang tính chất tham khảo, vui lòng bấm{' '}
                  <strong>‘Bắt Đầu Vay Ngay’</strong> để kiểm tra khả năng duyệt
                  cho gói vay
                </p>
              </div>
            </div>
          </div>
        </div>
        <Modal
          className={s.modal}
          modalContentClass={s.modalContent}
          onClose={this.onCloseModal}
          isOpen={isOpenModal}
        >
          {!isAboutModal && (
            <picture>
              <source srcSet={popupWebp} type="image/webp" />
              <source srcSet={popup} type="image/png" />
              <img className={s.popupImage} src={popup} alt="Popup images" />
            </picture>
          )}
          {isAboutModal && (
            <div className={s.aboutModal}>
              <span className={s.aboutModalTitle}>
                Về công ty Home Credit Việt Nam
              </span>
              <div className={s.aboutModalContent}>
                Thành lập từ năm 1997 và đã có mặt tại Việt Nam từ năm 2007,
                Home Credit Vietnam là Công ty Tài Chính được cấp phép và hoạt
                động dưới sự giám sát của Ngân hàng Nhà nước Việt Nam. Trong 14
                năm hoạt động, Home Credit đã có mặt tại 63 tỉnh thành, phục vụ
                hơn 14 triệu khách hàng Việt Nam thực hiện những dự định tài
                chính của mình.
              </div>
              <Button
                onClick={this.onCloseModal}
                className={classNames(s.btnStart, s.aboutModalButton)}
              >
                Đã xem
              </Button>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ internal }) => ({
  settings: internal.settings,
});

const mapDispatchToProps = dispatch => ({
  resetAlert: () => dispatch(clearAlert()),
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(s),
);

export default enhance(StartLoanComponent);
